import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Premeditation",
    "spell_shadow_possession",
    [
      "When used, adds 2 combo points to your current target. When the target dies, the cooldown of Premeditation is reset.",
    ],
    1,
    [[]],
    null,
    null,
    null,
    null,
    "Instant",
    "2 min cooldown",
    null,
    { isNew: false, isChanged: true, isMoved: false }
  ),
  null,
  null,
];

export default tier7;
